import React from 'react';
import { testId } from '../../../../utils/testIds';
import { RENDER_MODE } from '../../constants';

function NumberField({ config, value, onChange, onBlur, disabled, required, error, renderMode }) {
  const displayValue = value ?? '';

  if (renderMode === RENDER_MODE.CARD || renderMode === RENDER_MODE.GRID) {
    return (
      <span className="field-engine-number-value">
        {displayValue !== '' ? String(displayValue) : <span className="field-engine-empty">—</span>}
      </span>
    );
  }

  const maxLength = config.maxLength || null;

  return (
    <input
      id={config.fieldKey}
      data-test={testId('field', config.fieldKey, 'input')}
      name={config.fieldKey}
      type="number"
      step="1"
      className={`field-engine-input field-engine-input--number${error ? ' field-engine-input--error' : ''}${disabled ? ' disabled' : ''}`}
      value={displayValue}
      onChange={e => {
        const nextValue = e.target.value;
        const digitCount = nextValue.replace(/-/g, '').length;
        if (maxLength && digitCount > maxLength) return;
        onChange(nextValue);
      }}
      onBlur={onBlur}
      disabled={disabled}
      required={required}
      aria-required={required}
      aria-invalid={!!error}
      placeholder={config.fieldSettings?.placeholder ?? config.label ?? ''}
    />
  );
}

export default NumberField;
